import { z } from 'zod';
import { E2EFlowPathSchema } from './e2eFlowTemplate.js';
/**
 * E2E Flow Version source types
 * Indicates how the version was created
 */
export const E2EFlowVersionSource = z.enum([
    'analysis', // Created during initial project analysis
    'enhancement', // Created from AI enhancement
    'regeneration', // Created from single flow regeneration
    'manual', // Manually created/edited by user
]);
/**
 * E2E Flow Version schema
 * Represents a versioned snapshot of an individual E2E flow
 */
export const E2EFlowVersionSchema = z.object({
    id: z.string(),
    flowId: z.string(),
    diagramId: z.string(),
    flowData: E2EFlowPathSchema,
    version: z.number(),
    parentId: z.string().nullable(),
    isLatest: z.boolean(),
    source: E2EFlowVersionSource,
    createdAt: z.string().or(z.date()),
    updatedAt: z.string().or(z.date()),
});
/**
 * E2E Flow Version summary for listing
 */
export const E2EFlowVersionSummarySchema = z.object({
    id: z.string(),
    flowId: z.string(),
    version: z.number(),
    isLatest: z.boolean(),
    source: E2EFlowVersionSource,
    createdAt: z.string().or(z.date()),
    // Summary data from flowData
    flowName: z.string(),
    stepCount: z.number(),
    isComplete: z.boolean(),
});
/**
 * E2E Flow export format options
 */
export const E2EFlowExportFormat = z.enum([
    'png', // Raster image
    'svg', // Vector image
    'json', // Raw flow data
    'mermaid', // Mermaid diagram code
]);
/**
 * E2E Flow export options
 */
export const E2EFlowExportOptionsSchema = z.object({
    format: E2EFlowExportFormat,
    width: z.number().optional(),
    height: z.number().optional(),
    backgroundColor: z.string().optional(),
    includeMetadata: z.boolean().optional(),
});
/**
 * Response from flow regeneration endpoint
 */
export const E2EFlowRegenerateResponseSchema = z.object({
    success: z.boolean(),
    flowId: z.string(),
    newVersionId: z.string(),
    version: z.number(),
    previousVersionId: z.string().nullable(),
    message: z.string(),
});
//# sourceMappingURL=e2eFlowVersion.js.map